import templateUrl from './sidebar-widget.html'
import './sidebar-widget.scss'

const ProjectWebscannerSidebarWidgetComponent = {
  bindings: {
    project: '<',
    showTopDivider: '<',
    showBottomDivider: '<'
  },
  templateUrl,
  controller: class ProjectWebscannerSidebarWidgetComponent {
    constructor (ProjectWebscannerService, UserService, ModalService, ExperimentService, SegmentAnalytics, $scope) {
      'ngInject'
      this.ProjectWebscannerService = ProjectWebscannerService
      this.UserService = UserService
      this.ModalService = ModalService
      this.ExperimentService = ExperimentService
      this.SegmentAnalytics = SegmentAnalytics
      this.$scope = $scope

      this.isFeatureDisabled = this.ExperimentService.isOff('webscanner-app')
      this.isLoading = false
      this.isStartingScan = false
      this.scan = null
      this.error = null
      this.startScanError = null
    }

    $onInit () {
      this.loadLatestScan()

      this.$scope.$watch(() => this.project.websiteUrl, (newUrl, oldUrl) => {
        if (newUrl !== oldUrl && newUrl) {
          this.loadLatestScan()
        }
      })
    }

    loadLatestScan () {
      this.isLoading = true
      this.error = null
      this.ProjectWebscannerService.fetchLatestScan(this.project.id)
        .then(scan => {
          this.scan = scan
        })
        .catch(err => {
          if (err.data?.error === 'not_found') {
            this.scan = null
          } else {
            this.error = err.data?.message || 'Failed to load scan data.'
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }

    get statusLabel () {
      return this.ProjectWebscannerService.statusLabel(this.scan?.status)
    }

    get statusClass () {
      return this.ProjectWebscannerService.statusClass(this.scan?.status)
    }

    get isScanPending () {
      return this.scan?.status === 'pending'
    }

    get isScanInProgress () {
      return this.scan?.status === 'in_progress'
    }

    get isScanActive () {
      return this.isScanPending || this.isScanInProgress
    }

    get performanceSummary () {
      return this.ProjectWebscannerService.performanceSummary(this.scan)
    }

    get truncatedUrl () {
      if (!this.scan?.url) return ''
      return this.scan.url.length > 40
        ? this.scan.url.substring(0, 40) + '...'
        : this.scan.url
    }

    $onDestroy () {}

    trackReportViewed () {
      this.SegmentAnalytics.trackEvent('webscanner report viewed', {
        source: 'sidebar_widget',
        projectId: this.project?.id,
        scanId: this.scan?.id,
        url: this.scan?.url
      })
    }

    openWebscannerModal () {
      this.SegmentAnalytics.trackEvent('webscanner history opened', {
        projectId: this.project?.id
      })
      this.ModalService.open({
        closeOnBackdrop: false,
        closeIcon: true,
        class: 'webscanner-history-modal cdbl-modal--size-large cdbl-modal--style-with-dividers cdbl-modal--style-with-sticky-header-and-footer',
        template: `
          <cdbl-project-webscanner-scan-history-modal
            project-id="$ctrl.modal.projectId">
          </cdbl-project-webscanner-scan-history-modal>`,
        projectId: this.project?.id,
      })
    }

    startScan () {
      if (this.isStartingScan) return
      this.isStartingScan = true
      this.startScanError = null
      this.error = null
      this.SegmentAnalytics.trackEvent('webscanner manual scan started', {
        projectId: this.project?.id,
        url: this.project?.websiteUrl
      })
      this.ProjectWebscannerService.startScan(this.project.id)
        .then(scan => {
          this.scan = scan
        })
        .catch(err => {
          this.startScanError = err.data?.message || 'Failed to start scan. Please try again.'
        })
        .finally(() => {
          this.isStartingScan = false
        })
    }

    openWebsiteUrlModal () {
      const vm = this
      this.ModalService.open({
        closeOnBackdrop: true,
        closeIcon: true,
        layout: 'default',
        class: 'website-url-modal',
        template: `<cdbl-website-url-modal project="$ctrl.modal.project"></cdbl-website-url-modal>`,
        project: vm.project
      })
    }
  }
}

export default ProjectWebscannerSidebarWidgetComponent
